import { TreeNodeData } from '../types';
import { treePrefixRenderer } from '../helpers/tree.helper';

export function resetTemporaryNode(nodeData: TreeNodeData) {
  nodeData.temporaryNode = undefined;
  nodeData.temporaryState = undefined;
}
